import React from 'react'
import { Castle } from 'lucide-react'
import { formatPercent } from '../utils/format'
import { toneColor, convictionTone } from '../utils/tone'
import { useDesk } from '../deskContext'

export default function MoatPanel({ moat }) {
  const desk = useDesk()
  if (!moat || (!moat.summary && !(moat.factors?.length))) return null

  const overall = toneColor(convictionTone(moat.strength ?? 0))

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center justify-between gap-3 mb-1 flex-wrap">
        <div className="flex items-center gap-2">
          <Castle className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
          <h2 className="text-lg font-bold">Competitive Moat</h2>
          <span className="text-sm text-[var(--onds-text-dim)]">{desk.battery ? 'silicon anode vs graphite and peers' : 'what makes Ondas defensible'}</span>
        </div>
        {moat.rating && (
          <span className="onds-chip" style={{ color: overall, borderColor: `${overall}55`, backgroundColor: `${overall}14` }}>
            {moat.rating} moat{moat.strength != null ? ` · ${formatPercent(moat.strength, 0)}` : ''}
          </span>
        )}
      </div>

      {moat.summary && <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed mb-4">{moat.summary}</p>}

      <div className="grid sm:grid-cols-2 gap-3">
        {(moat.factors ?? []).map((f, i) => {
          const color = toneColor(convictionTone(f.strength ?? 0))
          return (
            <div key={i} className="rounded-xl p-4 border" style={{ backgroundColor: 'var(--onds-surface)', borderColor: 'var(--onds-border)' }}>
              <div className="flex items-start justify-between gap-2 mb-1">
                <h3 className="font-semibold leading-tight">{f.title}</h3>
                {f.type && (
                  <span className="text-[10px] uppercase tracking-wider text-[var(--onds-text-dim)] shrink-0">{f.type}</span>
                )}
              </div>
              <div className="flex items-center gap-2 mb-2">
                <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--onds-border)' }}>
                  <div className="h-full rounded-full" style={{ width: `${Math.round((f.strength ?? 0) * 100)}%`, backgroundColor: color }} />
                </div>
                <span className="text-xs font-semibold tabular-nums" style={{ color }}>{formatPercent(f.strength ?? 0, 0)}</span>
              </div>
              <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed">{f.description}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
